import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "It is a feature that allows you to share access to your lock. You will be able to choose the access recipients, approve access to the lock and also allow multi-approval.",
    more: "Instructions",
    back: "Back",
  },
  ja: {
    reply1:
      "これは、ロックへのアクセスを共有できる機能です。アクセス受信者を選択したり、ロックへのアクセスを承認したり、複数承認を許可したりすることができます。",
    more: "説明書",
    back: "戻る",
  },
  es: {
    reply1:
      "Es una función que le permite compartir el acceso a su cerradura. Podrás elegir los destinatarios del acceso, aprobar el acceso a la cerradura y también permitir la aprobación múltiple.",
    more: "Instrucciones",
    back: "Atrás",
  },
});

class MultiApproval extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "instruction_qns", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "instruction_qns",
          trigger: "instruction_qns",
        });
      });
    }
  };

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "instruction_qns" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick}
            disabled={clicked}
          >
            {localizationStrings.more}
          </button>
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default MultiApproval;
